import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import { BoardsNewPost } from 'components/BoardsPost'

const BoardsNewPostPage: FC = () => {
  return (
    <UserProtectedRoute>
      <BoardsNewPost />
    </UserProtectedRoute>
  )
}

export default BoardsNewPostPage
